import React from "react";
import Lottie from "lottie-react";

import * as loading from "../assets/img/global/pehLoading.json";

const Loader = () => {
  return (
    <div className="loading z-[100] absolute top-0 left-0">
      <div className="container">
        <div className="loader fixed w-[150px] h-[150px] top-[100px] left-[50%] m-auto translate-x-[-50%]">
          <Lottie animationData={loading} loop={true} />
        </div>
      </div>
    </div>
  );
};

export default Loader;
